import { createContext, useContext } from 'react'

export type ServicesUiContext = {
  selectHit: (hitId: string) => void
  selectedHit: string | null
}

const ServicesUiContext = createContext<ServicesUiContext>({
  selectHit: () => null,
  selectedHit: null
})

export const ServicesUiProvider = ServicesUiContext.Provider

export const useServicesUi = () => useContext(ServicesUiContext)
